<app-action-button-with-embedded-spinner [actionObservable]="updateZCVStatus.bind(this)" [icon]="'replay'"
    [hint]="'Update Zoning Code Version GAPI data statistic'"></app-action-button-with-embedded-spinner>